import React from 'react'
import { Link,useLocation } from 'react-router-dom';
import Subitem from './subitem';

const Mainmenuitem = ({title,to,Icon,activeTarger,listitems}) => {
    const currentRoute = useLocation().pathname.toLowerCase();
  return (
    <div className={currentRoute.includes(activeTarger) ? "admin_sidebar_mainmenuitem_wrapper active" : "admin_sidebar_mainmenuitem_wrapper"}>
      <Link to={to}>
        <div className='admin_sidebar_mainmenuitem_container'>
            <div className='admin_sidebar_mainmenuitem_icon'>
                {currentRoute.includes(activeTarger) &&
                    <Icon fill='#2a2a2a'/>
                }
                {!currentRoute.includes(activeTarger) &&
                    <Icon fill='#6D7175'/>
                }
            </div>
            <div className='admin_sidebar_mainmenuitem_text'>
                <h6>{title}</h6>
            </div>
        </div>
      </Link>
      {listitems &&
        <div className='admin_siderbar_subitems_container'>
            {
                listitems.map((item,index)=>{
                    return(
                        <Subitem to={item.to} title={item.title} key={index} />
                    )
                })
            }
        </div>
      }
    </div>
  )
}

export default Mainmenuitem
